document.addEventListener("DOMContentLoaded", function () {
    const disableBodyScroll = bodyScrollLock.disableBodyScroll;
    const enableBodyScroll  = bodyScrollLock.enableBodyScroll;

    const selectors = {
        container: ".product",
        colorGroup: ".js-color-group",
        color: ".js-color",
        colorLink: ".js-color-link",
        popup: ".js-popup",
        openPopup: ".js-open-popup",
        closePopup: ".js-close-popup",
        customizePopup: ".js-customize-it-popup",
        customizeOpenPopup: ".js-open-customize-it",
        customizeClosePopup: ".js-close-customize-it",
        processingSelect: ".js-processing-select",
        processingOption: ".js-processing-option",
        processingCheckbox: ".js-processing-checkbox",
        processingLabel: ".js-processing-label",
        purchaseButton: ".js-purchase-button",
        optionLabel: ".js-option-label",
        priceContainer: ".js-price-container",
        optionSelect: ".js-option-select",
        sampleButton: ".js-sample-button",
        rushSampleButton: ".js-rush-sample-button"
    };

    const classes = {
        active: "active",
        lock: "lock"
    }

    const container = document.querySelector(selectors.container);

    if (!container) {
        return;
    }

    initColorChange();
    initClickHandler();
    initProcessing();
    initOptions();

    function initColorChange() {
        const colorGroup = container.querySelector(selectors.colorGroup);
        const color      = container.querySelector(selectors.color);
        const colorLinks = container.querySelectorAll(selectors.colorLink);

        if (!colorGroup || !color || !colorLinks.length) {
            return;
        }


        const activeColor = [...colorLinks].find(link => link.dataset.active);


        colorGroup.addEventListener("mouseover", function (event) {
            const colorLink = event.target.closest(selectors.colorLink);

            if (!colorLink) {
                color.innerHTML = color.dataset.color;
                activeColor?.classList.add(classes.active);

                return;
            }

            color.innerHTML = colorLink.dataset.color;
            activeColor?.classList.remove(classes.active);
        });

        colorGroup.addEventListener("mouseleave", function (event) {
            color.innerHTML = color.dataset.color;
            activeColor?.classList.add(classes.active);
        });
    }

    function initClickHandler() {
        const customizePopup = container.querySelector(selectors.customizePopup);

        container.addEventListener("click", function (event) {
            const closePopup = event.target.closest(selectors.closePopup);

            if (closePopup) {
                const popup = closePopup.closest(selectors.popup);

                if (!popup) {
                    return;
                }

                popup.classList.remove(classes.active);
                popup.setAttribute("aria-expanded", "false");
                bodyScrollLock.clearAllBodyScrollLocks();
                return;
            }

            const openPopup = event.target.closest(selectors.openPopup);

            if (openPopup) {
                const popup = openPopup.querySelector(selectors.popup);

                if (!popup) {
                    return;
                }

                popup.classList.add(classes.active);
                popup.setAttribute("aria-expanded", "true");
//                 bodyScrollLock.disableBodyScroll(popup);
                return;
            }

            const customizeOpenPopup = event.target.closest(selectors.customizeOpenPopup);

            if (customizeOpenPopup && !customizeOpenPopup.hasAttribute("disabled") && customizePopup) {
                customizePopup.classList.add(classes.active);
                customizePopup.setAttribute("aria-expanded", "true");
                bodyScrollLock.disableBodyScroll(customizePopup);
                return;
            }

            const customizeClosePopup = event.target.closest(selectors.customizeClosePopup);

            if (customizeClosePopup && customizePopup) {
                customizePopup.classList.remove(classes.active);
                customizePopup.setAttribute("aria-expanded", "false");
                bodyScrollLock.clearAllBodyScrollLocks();
                return;
            }

        });
    }

    function initProcessing() {
        const processingSelect   = container.querySelector(selectors.processingSelect);
        const processingCheckbox = container.querySelector(selectors.processingCheckbox);
        const processingLabel    = container.querySelector(selectors.processingLabel);

        if (!processingSelect || !processingCheckbox) {
            return;
        }

        setTimeout(function () {
            if(processingLabel) {
                processingSelect.value = "off";
            } else {
                processingSelect.value === "on" ? processingCheckbox.checked = true : processingCheckbox.checked = false;
                enableBuying();
            }

            processingSelect.addEventListener("change", function () {
                processingSelect.value === "on" ? processingCheckbox.checked = true : processingCheckbox.checked = false;
            });

            processingSelect.addEventListener("change", function () {
                if (processingLabel) {
                    processingLabel.remove();
                }

                enableBuying()
            }, {once: true});
        }, 1000);
    }

    function initOptions() {
        const optionSelects = [...container.querySelectorAll(selectors.optionSelect)];

        setTimeout(function () {
            optionSelects.forEach(optionSelect => {
                optionSelect.value = optionSelect.querySelector(selectors.optionLabel).getAttribute("value");
                optionSelect.addEventListener("change", () => {
                    const optionLabel = optionSelect.querySelector(selectors.optionLabel);

                    if (optionLabel) {
                        optionLabel.remove();
                    }
                    enableBuying()
                });
            });
        }, 1000);
    }

    function enableBuying() {
        const purchaseButton     = container.querySelector(selectors.purchaseButton);
        const priceContainer     = container.querySelector(selectors.priceContainer);
        const processingLabel    = container.querySelector(selectors.processingLabel);
        const optionLabel        = container.querySelector(selectors.optionLabel);
        const sampleButton       = container.querySelector(selectors.sampleButton);
        const rushSampleButton   = container.querySelector(selectors.rushSampleButton);
        const customizeOpenPopup = container.querySelector(selectors.customizeOpenPopup);

        if (!processingLabel && !optionLabel) {
            if (purchaseButton) {
                purchaseButton.removeAttribute("disabled");
                purchaseButton.removeAttribute("aria-label");
            }

            if (sampleButton) {
                sampleButton.removeAttribute("disabled");
                sampleButton.removeAttribute("aria-label");
            }

            if (rushSampleButton) {
                rushSampleButton.removeAttribute("disabled");
                rushSampleButton.removeAttribute("aria-label");
            }

            if(customizeOpenPopup) {
                customizeOpenPopup.removeAttribute("disabled");
                customizeOpenPopup.removeAttribute("aria-label");
            }

            if (priceContainer) {
                priceContainer.classList.remove("tw-hidden");
            }
        } else if (!optionLabel) {
            if (sampleButton) {
                sampleButton.removeAttribute("disabled");
                sampleButton.removeAttribute("aria-label");
            }

            if(rushSampleButton) {
                rushSampleButton.removeAttribute("disabled");
                rushSampleButton.removeAttribute("aria-label");
            }

            if (priceContainer) {
                priceContainer.classList.remove("tw-hidden");
            }

            if(customizeOpenPopup) {
                customizeOpenPopup.removeAttribute("disabled");
                customizeOpenPopup.removeAttribute("aria-label");
            }
        }
    }
});